import(/* webpackMode: "eager" */ "/workspace-install/projects/astrolive-app/modules/Astro/AstroPageHeader/index.tsx")